import { PrismicLink as _PrismicLink } from '@prismicio/react';
import { LOCAL_URLS } from '../lib/config';

// Set default target="_blank" on external links
//
// Keep in sync with prismicio.js
export default function PrismicLink(p) {
  if (!p.target && (isRemoteLink(p.field) || isRemoteDocument(p.document))) {
    return <_PrismicLink {...p} target="_blank" />;
  } else {
    return <_PrismicLink {...p} />;
  }
}

function isRemoteLink(link) {
  return link && link.link_type === 'Web' && isRemoteUrl(link.url);
}

function isRemoteDocument(doc) {
  return doc && doc.type === 'page' && isRemoteLink(doc.data?.listRedirect);
}

// return whether the url is on the same website or not (incl. subdomains)
function isRemoteUrl(url) {
  if (!url) return false;
  const _url = new URL(url);
  return LOCAL_URLS.find((cmp) => _url.origin === cmp.origin) === undefined;
}
